import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

  // main.ts or your entry file
(async () => {
  if (environment.production) {
    await import('zone.js/dist/zone');
  }
  // Rest of your bootstrap code here
})();